import { useNavigate } from 'react-router-dom';

export default function NotFound() {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate('/');
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4 font-inter transition-colors duration-300
      bg-gray-100 text-gray-900 dark:bg-gray-900 dark:text-white"
    >
      <div
        className="p-8 md:p-12 rounded-xl shadow-2xl text-center max-w-lg w-full transition-colors duration-300
        bg-white dark:bg-gray-800"
      >
        <h1 className="text-7xl md:text-9xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-600 mb-4 animate-pulse">
          404
        </h1>
        <h2 className="text-3xl md:text-4xl font-bold mb-4">Page Not Found</h2>
        <p className="text-lg mb-8 text-gray-600 dark:text-gray-300">
          Oops! The page you're looking for doesn't exist or has been moved.
          Please check the URL or go back to the homepage.
        </p>
        <button
          onClick={handleNavigate}
          className="bg-purple-600 hover:bg-purple-700 text-white font-semibold py-3 px-6 rounded-lg shadow-md transition duration-300 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-opacity-75"
        >
          Go to Homepage
        </button>
      </div>
    </div>
  );
}
